export default {
  urlBuilder(url) {
    if (url.indexOf("https://") !== -1) return url;
    if (url.indexOf("http://") !== -1) return url;
    return "https://" + url;
  }
};
